import { CreateEmailPayload, TeamsResponse, updateTeamsPayload } from '../features/email/emailType';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_locations = '/{0}/emails.list';
const create_locations = '{0}/emails.add';
const update_location = '/{0}/{1}/emails.update';
const fetch_locations_status = '/{0}/emails.list';
const fetch_pipeline_details = '/{0}/{1}/emails.detail'

const credentialsConfig = {
    withCredentials: true,
}


export const fetchEmailData = async (baseId: number): Promise<TeamsResponse> => {
    const fetch_location_data = formatUrl(fetch_locations, [baseId]);
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};

export const fetchEmailDataStatus = async (baseId: number, status?: string): Promise<TeamsResponse> => {
    let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
    if (status) {
        fetch_location_data += `?status=${status}`;
    }
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};


export const createLoationData = async (data: CreateEmailPayload, userId: number): Promise<TeamsResponse> => {
    const base_create_location = formatUrl(create_locations, [userId]);
    return post<TeamsResponse>(base_create_location, data, credentialsConfig);
};



export const updateLocationData = async (id: number, baseId: number, data: updateTeamsPayload): Promise<TeamsResponse> => {
    const update_teams_data = formatUrl(update_location, [id, baseId]);
    return put<TeamsResponse>(update_teams_data, data, credentialsConfig);
};

export const fetchPipelineDetails = async (baseId: number, userId: string): Promise<TeamsResponse> => {
    const fetch_pipeline_details1 = formatUrl(fetch_pipeline_details, [baseId, userId]);
    return get<TeamsResponse>(fetch_pipeline_details1, credentialsConfig);
};
